const cognitoConfig = {
  domain: process.env.REACT_APP_COGNITO_DOMAIN,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirectUri: process.env.REACT_APP_COGNITO_REDIRECT_URI || 'http://localhost:3000/callback',
  logoutUri: process.env.REACT_APP_COGNITO_LOGOUT_URI || 'http://localhost:3000/login',
  region: process.env.REACT_APP_COGNITO_REGION,
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
};

export function getLoginUrl() {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: cognitoConfig.clientId,
    redirect_uri: cognitoConfig.redirectUri,
    scope: 'openid email profile',
  });
  return `https://${cognitoConfig.domain}/login?${params.toString()}`;
}

export function getLogoutUrl() {
  const params = new URLSearchParams({
    client_id: cognitoConfig.clientId,
    logout_uri: cognitoConfig.logoutUri,
  });
  return `https://${cognitoConfig.domain}/logout?${params.toString()}`;
}

export function getTokenUrl() {
  return `https://${cognitoConfig.domain}/oauth2/token`;
}

export default cognitoConfig;
